import { ReactElement, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';
import { OrganisationUnitTreeProvider } from 'shared/features/organisation/providers/organisation-unit-tree-provider';

import OrganisationTree from 'features/organisation/views/organisation-tree/organisation-tree.component';

import './role-organisation-picker.component.scss';

interface IProps {
  viewingMode: ViewingMode;
  initialSelectedOrganisationUnit?: string;
}

const RoleOrganisationPickerComponent = (props: Readonly<IProps>): ReactElement => {
  const form = useFormContext();
  const { t } = useTranslation('role');

  const [showValidation, setShowValidation] = useState<boolean>(false);

  const onSelectOrganisationUnit = (selectedNode: OrganisationTreeNode): void => {
    form.setValue('accessOrganisationUnitId', selectedNode.id, { shouldDirty: true });
    setShowValidation(false);
  };

  const onDeselectOrganisationUnit = (): void => {
    form.setValue('accessOrganisationUnitId', '', { shouldDirty: true });
    setShowValidation(true);
  };

  useEffect(() => {
    form.setValue('accessOrganisationUnitId', props.initialSelectedOrganisationUnit ?? '');
    setShowValidation(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.viewingMode]);

  useEffect(() => {
    if (!showValidation && form.formState.isSubmitted && props.viewingMode !== 'viewing') {
      setShowValidation(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.formState.isSubmitted]);

  return (
    <>
      {props.viewingMode !== 'viewing' && showValidation && (
        <span className="validationError">{t('validation.noOrganisationUnitSelected')}</span>
      )}
      <OrganisationUnitTreeProvider.All>
        <OrganisationTree
          disableSelection={props.viewingMode === 'viewing'}
          showSelectionInViewMode={props.viewingMode === 'viewing'}
          initialSelectedOrganisationUnit={props.initialSelectedOrganisationUnit}
          onSelectOrganisationUnit={onSelectOrganisationUnit}
          onDeselectOrganisationUnit={onDeselectOrganisationUnit}
        />
      </OrganisationUnitTreeProvider.All>
    </>
  );
};

export default RoleOrganisationPickerComponent;
